"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.status.active': '活跃',
    'settings.status.inactive': '不活跃',
    'settings.status.enabled': '已启用',
    'settings.status.disabled': '已禁用',
    'settings.status.connected': '已连接',
    'settings.status.notConnected': '未连接',
    'settings.status.authenticated': '已认证',
    'settings.status.notAuthenticated': '未认证',
};
